/** 文控 API 契约常量（与后端枚举保持一致） */
export const DOC_CONTROL_SYNC_TRIGGER_TYPE = {
  MANUAL: 'manual',
  SCHEDULED: 'scheduled'
} as const

export const DOC_CONTROL_SYNC_STATUS = {
  SYNCING: 'syncing',
  SUCCESS: 'success',
  FAILED: 'failed'
} as const

export const DOC_CONTROL_DOCUMENT_SYNC_STATUS = {
  SYNCED: 'synced'
} as const

export const DOC_CONTROL_DICT_TYPE = {
  COUNTRY_REGION: 'country_region',
  CERT_TYPE: 'cert_type',
  CERT_PROJECT: 'cert_project',
  PRODUCT_CATEGORY: 'product_category',
  CERT_ORG: 'cert_org'
} as const

export type DocControlSyncTriggerType =
  typeof DOC_CONTROL_SYNC_TRIGGER_TYPE[keyof typeof DOC_CONTROL_SYNC_TRIGGER_TYPE]

export type DocControlDictType =
  typeof DOC_CONTROL_DICT_TYPE[keyof typeof DOC_CONTROL_DICT_TYPE]
